
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6PXdj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4cf08f12332ff262$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $4cf08f12332ff262$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': "\u53D6\u6D88",
    'fabric.linkPicker.button.insert': "\u63D2\u5165",
    'fabric.linkPicker.button.save': "\u5132\u5B58",
    'fabric.linkPicker.clearLink': "\u6E05\u9664",
    'fabric.linkPicker.clearLinkText': "\u6E05\u9664\u6587\u5B57",
    'fabric.linkPicker.hyperlink.searchLinkResults': "{count, plural, =0 {\u6C92\u6709\u627E\u5230\u4EFB\u4F55\u7D50\u679C} other {\u627E\u5230 {count,number} \u500B\u7D50\u679C}}",
    'fabric.linkPicker.linkAriaLabel': "\u5728\u6B04\u4F4D\u4E2D\u8F38\u5165\u6216\u8CBC\u4E0A\u9023\u7D50",
    'fabric.linkPicker.linkHelperTextAriaLabel': "\u9023\u7D50\u986F\u793A\u8F14\u52A9\u5DE5\u5177\u6587\u5B57",
    'fabric.linkPicker.linkHelperTextLabel': "\u70BA\u6B64\u9023\u7D50\u63D0\u4F9B\u6A19\u984C\u6216\u63CF\u8FF0",
    'fabric.linkPicker.linkInvalid': "\u8ACB\u8F38\u5165\u6709\u6548\u7684 URL\u3002",
    'fabric.linkPicker.linkLabel': "\u9023\u7D50",
    'fabric.linkPicker.linkPlaceholder': "\u8CBC\u4E0A\u9023\u7D50",
    'fabric.linkPicker.linkTextAriaLabel': "\u9023\u7D50\u986F\u793A\u6587\u5B57",
    'fabric.linkPicker.linkTextLabel': "\u986F\u793A\u6587\u5B57 (\u9078\u64C7\u6027)",
    'fabric.linkPicker.linkTextPlaceholder': "\u8981\u986F\u793A\u7684\u6587\u5B57",
    'fabric.linkPicker.listTitle.recentlyViewed': "\u6700\u8FD1\u6AA2\u8996\u7684\u9805\u76EE",
    'fabric.linkPicker.listTitle.results': "\u7D50\u679C",
    'fabric.linkPicker.search.error.description': "\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u5982\u679C\u6301\u7E8C\u767C\u751F\u932F\u8AA4\uFF0C\u8ACB\u9023\u7D61 <a>Atlassian \u652F\u63F4\u4EBA\u54E1</a>\u3002",
    'fabric.linkPicker.search.error.heading': "\u6211\u5011\u5728\u8F09\u5165\u8CC7\u6599\u6642\u9047\u5230\u554F\u984C\u3002",
    'fabric.linkPicker.search.error.retry': "\u91CD\u65B0\u6574\u7406",
    'fabric.linkPicker.search.linkAriaLabel': "\u7576\u60A8\u5728\u6B04\u4F4D\u4E2D\u8F38\u5165\u5167\u5BB9\u6642\uFF0C\u5EFA\u8B70\u6703\u986F\u793A\u5728\u4E0B\u65B9",
    'fabric.linkPicker.search.linkLabel': "\u641C\u5C0B\u6216\u8CBC\u4E0A\u9023\u7D50",
    'fabric.linkPicker.search.linkPlaceholder': "\u5C0B\u627E\u6700\u8FD1\u7684\u9023\u7D50\u6216\u8CBC\u4E0A\u65B0\u9023\u7D50",
    'fabric.linkPicker.search.noResults.description': "\u8ACB\u4F7F\u7528\u4E0D\u540C\u7684\u5B57\u8A5E\u518D\u8A66\u4E00\u6B21\u3002",
    'fabric.linkPicker.search.noResults.heading': "\u6211\u5011\u627E\u4E0D\u5230\u4EFB\u4F55\u7B26\u5408\u60A8\u641C\u5C0B\u7684\u9805\u76EE\u3002",
    'fabric.linkPicker.status.submitting': "\u6B63\u5728\u63D0\u4EA4",
    'fabric.linkPicker.time.message.updated': "\u66F4\u65B0\u6642\u9593\uFF1A{time}",
    'fabric.linkPicker.time.message.viewed': "\u6AA2\u8996\u6642\u9593\uFF1A{time}",
    'fabric.linkPicker.unhandledError.description': "\u8ACB\u5617\u8A66\u91CD\u65B0\u8F09\u5165\u9801\u9762\u3002",
    'fabric.linkPicker.unhandledError.heading': "\u767C\u751F\u932F\u8AA4\uFF01"
};

});


//# sourceMappingURL=zh_TW.4675a2ac.js.map
